module.exports = __webpack_public_path__ + "media/assets/images/tour/welcome_main-507739b61327bc46bd8f52a1e2d78f01.jpg";